// The certificate panel under a product (AdminProducts.dc.html): on or off, and the rule that issues
// it. Each change saves at once (a direct write, owner and admin). "Came to at least 5 live sessions"
// is certificate_min_sessions 5. Turning it on with no rule yet picks the board's usual 1: every
// session watched and all homework ticked, or by hand for a 1-2-1. The prefix is on the settings page.
import { useState } from 'react'
import { Checkbox } from '../ui/index.js'
import { CERTIFICATE } from './copy.js'
import { setCertificate } from './data.js'

export function CertificatePanel({ api, product, onChange, id }) {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState(null)
  const on = Boolean(product.certificate_on)

  async function save(patch) {
    if (busy) return
    setBusy(true)
    setError(null)
    try {
      const row = await setCertificate(api, product.id, patch)
      onChange(row)
    } catch (e) { setError(e.message || String(e)) } finally { setBusy(false) }
  }

  const toggle = next => {
    const rule = product.certificate_rule || (product.type === 'client_space' ? 'by_hand' : 'all_watched_and_homework')
    save(next && !product.certificate_rule ? { on: true, rule } : { on: next })
  }

  return (
    <div className="ap-panel" id={id}>
      <Checkbox checked={on} disabled={busy} onChange={toggle} className="ap-cert-give">{CERTIFICATE.give(product.name)}</Checkbox>
      <div className="ap-cert-body">
        <span className="ap-label" id={`${id}-rule`}>{CERTIFICATE.completeWhen}</span>
        <div className="ap-rules" role="group" aria-labelledby={`${id}-rule`}>
          {CERTIFICATE.rules.map(r => (
            <button key={r.value} type="button" className="ap-rule" aria-pressed={product.certificate_rule === r.value}
              disabled={busy || !on} onClick={() => save({ on, rule: r.value })}>{r.label}</button>
          ))}
        </div>
        <p className="ap-panel-line">{on ? CERTIFICATE.on(product.name) : CERTIFICATE.off}</p>
        <p className="ap-panel-quiet">{CERTIFICATE.byHand}</p>
      </div>
      {error && <p className="ad-error" role="alert">{error}</p>}
    </div>
  )
}
